export const BYLINE = {
    MAP: {
        "Sports Network": true,
        "The Canadian Press": true,
        "The Associated Press": true,
    },
    REUTERS: "Thomson Reuters",
};

export const DEFAULT_CBC_IMAGE =
    "https://i.cbc.ca/1.470050.1431707740!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/default-headline-image-news.jpg";

export const FLAGS_WITH_SEPARATORS = ["OPINION", "FIRST PERSON", "ANALYSIS"];

export const DEFAULT_LEAD_PHOTOGALLERY = {
    id: "",
    aspectRatio: "4x3",
};

export const DEFAULT_LEAD_SEGMENT_OR_EPISODE_AUDIO = {
    runtime: 0,
    clipID: "",
    description: "",
    autoPlay: false,
};

export const DEFAULT_LEAD_VIDEO_OR_AUDIO = {
    runtime: 0,
    clipID: "",
    description: "",
    autoPlay: false,
    title: "",
};

const IMAGE_MASSES = {
    FULL: "full",
    MEDIUM: "medium",
    SMALL: "small",
    EXTRASMALL: "extrasmall",
};

export const DEFAULT_LEAD_IMAGE = {
    title: "",
    credit: "",
    url: "",
    showcaption: false,
    description: "",
    mass: IMAGE_MASSES.FULL,
    type: "image",
    alt: "",
    isAboveFold: true,
};

export const DEFAULT_CONTENT = {
    id: "",
    type: "",
    source: "",
    corrections: [],
    clarifications: [],
    headline: "",
    deck: "",
    description: "",
    byline: "",
    highlights: {},
    intlinks: [],
    externalLinks: [],
    updatedAt: 0,
    publishedAt: 0,
    publishedAtVerbal: "",
    displayComments: false,
    url: "",
    flag: "",
    body: "",
    keywords: "",
    segments: [],
    episode: {},
    attribution: {},
    isPreview: false,
    adExclusions: [],
    sponsorBio: {},
    subject: [],
    authorList: [],
    newsletter: "false",
    embedtypes: [],
    contentarea: "",
    subsection1: "",
    subsection2: "",
    subsection3: "",
    subsection4: "",
    wordcount: 0,
    gs_categories: [],
    gs_keywords: [],
};

export const DEFAULT_AUTHOR = {
    title: "",
    name: "",
    biography: "",
    sourceId: "",
    url: "",
    links: null,
    photoURL: "",
};

export const DEFAULT_ML_DRIVEN_RELATED_LINKS = [
    {
        title: "Title 1",
        url: "url 1",
    },
];

export const POLITICS_SECTION = "politics";

export const NEWS_SECTION = "news";

export const OPINION_SECTION_FLAGS = ["First Person", "Opinion"];
